import { isRealProduction } from 'Douleutaras/constants/system';

export const URLS = {
  AUTHENTICATION: {
    LOGIN: '/dashboard-v2/accounts/signin',
    IFRAME: '/dashboard-v2/accounts/signin/iframe',
    REDIRECT: '/dashboard-v2/accounts/redirect/:urlB64/:wrongToken',
    REGISTER_PRO: '/accounts/signup/seller'
  },
  CATEGORY: '/jobs/create/signup/:catId',
  BSDIR_CATEGORY: '/bsdir/:categorySlug/',
  BSDIR: {
    ROOT: '/bsdir',
    INDEX: '/bsdir/',
    PAGE: '/bsdir/:groupSlug/:pageSlug/'
  },
  MUNICIPALITY: '/dir/attica/:munSlug/',
  CLIENT_DASHBOARD: {
    INDEX: '/dashboard-v2',
    JOB: {
      INDEX: 'job/:jobId',
      PAYMENT_REQUEST_RECEIVED: 'payment-request-received/:reqId',
      PAYMENT_REQUEST_RECEIVED_COMPLETE: 'payment-request-received/:reqId/complete',
      CREATE_ONLINE_PAYMENT: 'create-online-payment/:bidId',
      CREATE_ONLINE_PAYMENT_COMPLETE: 'create-online-payment/:bidId/complete',
      REVIEW_BID: 'review-bid/:bidId',
      REVIEW_NPS: 'review-nps'
    },
    SETTINGS: 'settings/general',
    CCF_MODALS: {
      NEED_HELP: '/dashboard-v2/job/:jobId/need-help',
      DECLARE_INTEREST: '/dashboard-v2/job/:jobId/declare-interest',
      SOLVE_ISSUES: '/dashboard-v2/job/:jobId/solve-issue',
      CANCEL: '/dashboard-v2/job/:jobId/cancel'
    },
    CONVERSATION: {
      INDEX: 'inbox',
      THREAD: 'conversation/:conversationId',
      META: 'conversation/:conversationId/meta'
    },
    PRO_LIST: 'best-for-you',
    REVIEW_SHARE: 'review-share'
  },
  POST_JOB: {
    WEBVIEW: '/dashboard-v2/post-job/webview/:username',
    IFRAME: '/dashboard-v2/post-job/iframe'
  },
  PRO_PROFILE: {
    INDEX: '/dashboard-v2/profile/:username'
  },
  PRO_DASHBOARD: {
    INDEX: '/dashboard-v2/pro',
    BIDS: 'bids/:status',
    POST_JOB: 'post-job',
    DAILY_SUMMARY: 'daily-summary',
    WEEKLY_SUMMARY: 'weekly-summary',
    NOTIFICATIONS_CENTER: 'notifications',
    STATS_CENTER: {
      INDEX: 'stats-center',
      PERFORMANCE: 'performance',
      RANKING: 'ranking',
      SCORE: 'score',
      COMPETITORS: 'competitors'
    },
    STATUS_UPDATE: 'status-update/:bidId',
    STATUS_UPDATE_EXTERNAL: 'status-update-external/:jobId',
    JOB_PAGE: {
      INDEX: 'bid/:bidId',
      CUSTOMER_ONLINE_PAYMENT: 'customer-online-payment/:payId',
      CONTACT_CUSTOMER: 'contact-customer',
      SUSPICIOUS_REPORT: 'suspicious-report',
      STATUS_UPDATE: 'status-update'
    },
    JOB_PAGE_OUTER: 'external/:outerJobId',
    JOB_PAGE_OUTER_UPDATE: ':jobId/status-update-external',
    SETTINGS: {
      INDEX: 'settings',
      GENERAL: 'general',
      NOTIFICATIONS: 'notifications',
      PROFILE: 'profile',
      PROFILE_SERVICES: {
        INDEX: 'profile',
        PRICE_NEW: 'services/:categoryId/new',
        PRICE_EDIT: 'services/prices/:priceId',
        DETAIL_NEW: 'services/prices/:servicePriceId/details/new'
      },
      REVIEWS: 'reviews',
      TRANSACTIONS: {
        INDEX: 'transactions',
        INVOICES: 'invoices'
      },
      INVOICE_PAYMENT: 'transactions/invoices/payment',
      TOPUP: 'auto-top-up',
      PLANS: {
        INDEX: '',
        ROOT: 'plans',
        PAYMENT: 'plans/:plan/:backend/:backend_type'
      }
    },
    CONVERSATION: {
      INDEX: 'inbox',
      THREAD: 'conversation/:conversationId',
      META: 'conversation/:conversationId/meta'
    },
    CASHBACK: 'cashback',
    BONUS: 'bonus'
  },
  CONTACT_US: {
    INDEX: '/dashboard-v2/contact-us'
  },
  SELLER: {
    INDEX: '/dashboard/applicant/',
    STATS_CATEGORY: '/dashboard/statistics/category',
    CONCLUDED: '/dashboard/applicant/mywork/concluded',
    MY_JOBS: '/dashboard-v2/pro/bids/current',
    CONCLUDED_v2: '/dashboard-v2/pro/bids/concluded',
    CANCELLED: '/dashboard-v2/pro/bids/cancelled',
    PROPOSED: '/dashboard/applicant/featured/proposed'
  },
  USER: {
    PROFILE: '/profile/:username'
  },
  JOB: {
    MATCHING_ALGO: '/dashboard/employer/jobpost/:jobCategory/done/:jobId'
  },
  PUBLIC_REVIEW: '/dashboard-v2/r/:generatedId',
  JOB_DONE: '/dashboard-v2/jobdone/:jobId',
  SUPPORT: {
    CONTACT: '/contact_us/',
    CLEANING_JOB: '/dashboard/employer/cleaning/support/:jobId'
  },
  GUARANTY: {
    IE: '/yourpro-job-guarantee/',
    GR_CY: '/douleutaras-job-guarantee/'
  }
};

export const LEGACY_URLS = {
  JOB: '/jobs/:jobId'
};

// Routes cached at the Cloudflare edge, rendered identically for every visitor. Single source of
// truth for src/routes/dataRoutes.tsx (handle.anonymized), src/server/index.tsx (Express mounts)
// and src/layout/partials/LanguageSwitcher.tsx (URL-prefixed language scheme).
export const ANONYMIZED_PATHS: Array<string> = [
  URLS.PRO_PROFILE.INDEX,
  // bsdir is built in the dark: hidden on production until the LB sends /bsdir here
  ...(isRealProduction ? [] : [URLS.BSDIR.ROOT])
];
